<template>
	<div class="bubble">
		<img src="@/assets/images/surgery-arrow.png" alt="" class="arrow" />
		<div class="content">
			<slot></slot>
		</div>
	</div>
</template>

<script>
export default {
	name: 'Bubble',
}
</script>

<style scoped lang="less">
.bubble {
	background: #f5f8fc;
	border: 1px solid #ced6de;
	border-radius: 4px;
	padding: 15px;
	position: relative;
	.arrow {
		position: absolute;
		left: 28px;
		top: -12px;
	}
	.content {
	}
}
</style>
